import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withApollo } from "react-apollo";
import { push } from 'connected-react-router';
import { Breadcrumb, Button } from 'antd';
import AntIcon from '../shared/components/AntIcon';
import { Link } from 'react-router-dom';

import ModelForm from './components/ModelForm';

import withGraphqlData from '../shared/components/withGraphqlData';
import { parseFormErrors } from '../shared/utils/form_errors';
import { SneakerModelDetailsQuery, UpdateSneakerModelMutation } from './queries';

class EditModel extends Component {
  constructor(props) {
    super(props);

    this.state = { deleting: false, deleteError: null };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleSubmit(data) {
    this.setState({ deleteError: null });
    const { client, objectId, push } = this.props;
    return client.mutate({ mutation: UpdateSneakerModelMutation, variables: { id: objectId, update: data } })
      .then(() => push('/model'))
      .catch(parseFormErrors);
  }

  handleDelete() {
    this.setState({ deleting: true, deleteError: null });
    const { client, objectId, push } = this.props;
    return client.mutate({
      mutation: UpdateSneakerModelMutation,
      variables: { id: objectId, update: { isDeleted: true } },
    })
      .then(() => push('/model'))
      .catch(error => this.setState({
        deleting: false, deleteError: error.message,
      }));
  }

  render() {
    const { data } = this.props;
    const { deleting, deleteError } = this.state;

    const deleteButton = (
      <Button ghost disabled={deleting} loading={deleting} onClick={this.handleDelete} type="danger">
        <AntIcon type="delete" />Delete
      </Button>
    );

    return (
      <div id="edit-model">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/model">Model</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Edit Model</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <ModelForm
            initialValues={data.SneakerModel}
            onSubmit={this.handleSubmit}
            deleteButton={deleteButton}
            deleteError={deleteError}
          />
        </div>
      </div>
    );
  }
}

export default compose(
  withProps(({ match }) => ({
    objectId: match.params.id,
  })),
  withGraphqlData(
    SneakerModelDetailsQuery,
    (props) => ({ id: props.objectId }),
    'no-cache',
  ),
  connect(null, { push }),
  withApollo,
)(EditModel);
